import { Tab } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useContactDetail } from '../../../../contexts/contactDetailContext'
import { DocumentType } from '../../enums/DocumentType'
import { DocumentTabItem } from '../../types/DocumentTabItem'
import { useDocumentTabCounter } from './hooks/useDocumentTabCounter'

interface DocumentTabProps {
  active: boolean
  onClick: (documentType: DocumentType) => void
  tab: DocumentTabItem
}

export const DocumentTab = ({ active, onClick, tab }: DocumentTabProps): ReactElement => {
  const { t } = useTranslation()
  const { contact } = useContactDetail()
  const { counter } = useDocumentTabCounter(tab.documentType, contact.externalId)

  const handleTabClick = useCallback(() => {
    onClick(tab.documentType)
  }, [onClick, tab.documentType])

  return (
    <Tab active={active} badgeCounter={counter} icon={tab.icon} onClick={handleTabClick}>
      {t(tab.label)}
    </Tab>
  )
}
